import {
  ServiceRequestFieldType,
  ServiceRequestStep,
  ServiceRequestStepType,
} from '@domain/types';

import { TimeClock } from '@brand/icons';

export const ageOfBuildingStep: ServiceRequestStep = {
  type: ServiceRequestStepType.DETAILS,
  inSummary: true,
  title: `quote:ageOfBuilding.title`,
  subTitle: 'quote:ageOfBuilding.subTitle',
  segmentEvent: `Additional Info Filled in`,
  fields: [
    {
      type: ServiceRequestFieldType.TILES,
      summaryTitle: `quote:ageOfBuilding.summaryTitle`,
      props: {
        name: `age_of_building`,
        options: [
          {
            label: `quote:ageOfBuilding.options.less_than_10`,
            value: `younger_than_10_years`,
            icon: <TimeClock />,
          },
          {
            label: `quote:ageOfBuilding.options.more_than_10`,
            value: `older_than_10_years`,
            icon: <TimeClock />,
            // default: true,
          },
        ],
        validation: [`isRequired`],
      },
    },
  ],
};
